<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card class="rounded-lg" elevation="1">
          <v-card-title color="#f8f9fb" elevation="0">
            <v-row align="center" no-gutters>
              <v-col cols="auto">
                <span class="text-h6 font-weight-regular">{{
                  $t("event.title")
                }}</span>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="12" sm="4" md="3" class="px-3">
                <v-text-field
                  v-model="search"
                  label="Search"
                  append-icon="mdi-magnify"
                  single-line
                  hide-details
                  clearable
                  @input="
                    sessionStorage(search);
                    debounceInput();
                  "
                ></v-text-field>
              </v-col>
              <v-col cols="auto">
                <router-link to="/societyadmin/event/add" tag="button">
                  <v-btn class="primary">
                    <v-icon left> mdi-plus </v-icon>
                    Add Event
                  </v-btn>
                </router-link>
              </v-col>
            </v-row>
          </v-card-title>
          <v-divider></v-divider>

            <v-tabs color="primary" v-model="currentTab">
              <v-tab
                v-for="n in event_type"
                :key="n.id"
                @click="getEventTypeData(n.id)"
              >
                {{ n.text }}
              </v-tab>
            </v-tabs>
            <v-data-table
              :headers="headers"
              :items="events"
              :search="search"
              :options.sync="options"
              :server-items-length="totalRecords"
              :loading="loading"
              :page.sync="page"
            >

              <template v-slot:item.start_datetime="{ item }">
                {{ getFormattedDate(item.start_datetime) }}
              </template>

              <template v-slot:item.end_datetime="{ item }">
                {{ getFormattedDate(item.end_datetime) }}
              </template>

              <template v-slot:item.actions="{ item }">
                <v-btn
                  icon
                  color="secondary"
                  name="view_event"
                  title="View Event"
                  style="margin-left: -10px"
                  :to="'/societyadmin/event/view/' + item.id"
                >
                  <img src="@/components/icons/view.svg" width="18" height="18" />
                </v-btn>
                <v-btn
                  icon
                  color="secondary"
                  name="edit_event"
                  title="Edit Event"
                  :to="'/societyadmin/event/edit/' + item.id"
                >
                  <img src="@/components/icons/edit-02.svg" width="18" height="18" />
                </v-btn>
                <v-btn
                  icon
                  color="secondary"
                  name="delete_event"
                  title="Delete Event"
                  @click="confirmDelete(item.id)"
                >
                  <img src="@/components/icons/delete-01.svg" width="18" height="18" />
                </v-btn>
              </template>
            </v-data-table>
        </v-card>
      </v-flex>
      <v-dialog v-model="deleteDialog" width="500">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Confirm!!
          </v-card-title>
          <v-card-text class="mt-2">Are you sure want to delete? </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="deleteEvent(delete_id)">
              yes
            </v-btn>
            <v-btn color="primary" text @click="closeDialog"> No </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import { debounce } from "lodash";
import { mapMutations } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      search: "",
      headers: [
        {
          text: `${this.$t("event.headers.title")}`,
          value: "title",
          width: "30%",
        },
        {
          text: `${this.$t("event.headers.start_datetime")}`,
          value: "start_datetime",
          width: "25%",
        },
        {
          text: `${this.$t("event.headers.end_datetime")}`,
          value: "end_datetime",
          width: "25%",
        },
        {
          text: `${this.$t("event.headers.actions")}`,
          value: "actions",
          width: "15%",
          sortable: false,
        },
      ],
      user: {},
      event_value: "",
      addPermissionDialog: false,
      deleteDialog: false,
      events: [],
      delete_id: "",
      currentTab: 0,
      event_type: [
        {
          id: "upcoming",
          text: "Upcoming Event",
        },
        {
          id: "past",
          text: "Past Event",
        },
      ],
      options: {
        sortBy: ["created_at"]
      },
      totalRecords: 0,
      loading: false,
      page: 1,
    };
  },
  watch: {
    options: {
      handler () {
        this.getEventTypeData(this.event_type[this.currentTab].id);
      },
      deep: true,
    },
    currentTab: function() {
      this.options.page = 1;
      this.options.itemsPerPage = 10;
    }
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    deleteEvent(eventId) {
      let _self = this;
      _self.$axios.delete("societyadmin/events/" + eventId).then((response) => {
        let data = response.data;

        if (data.status) {
          _self.getEventTypeData(_self.event_type[_self.currentTab].id);
          this.deleteDialog = false;
          this.setAlert({
            showAlert: true,
            variant: "green accent-4",
            timeout: "2000",
            message: data.message,
          });
        } else {
          this.setAlert({
            showAlert: true,
            variant: "red accent-3",
            timeout: "2000",
            message: data.message,
          });
        }
      });
    },
    getEventTypeData(value) {
      //  let value=this.event_value
      this.event_value = sessionStorage.setItem("event_type", value);
      this.loading = true;
      let page = this.options.page;
      let itemsPerPage = this.options.itemsPerPage;
      let sortBy = this.options.sortBy.length > 0 ? this.options.sortBy[0] : "";
      let sortDesc = this.options.sortDesc.length > 0 ? this.options.sortDesc[0] : "";
      let search = this.search ? this.search : "";

      value = value ? value : 'upcoming';
      let _self = this;
      _self.$axios
        .get("societyadmin/" + value + "?society_id=" + _self.user.id +
            "&page=" + page +
            "&perPage=" + itemsPerPage +
            "&sortBy=" + sortBy +
            "&sortDesc=" + sortDesc +
            "&search=" + search
        )
        .then((response) => {
          this.loading = false;
          let data = response.data;
          if (data.status) {
            _self.events = data.events;
            _self.totalRecords = data.total;
            _self.page = data.page > data.lastPage ? 1 : data.page;
          } else {
            _self.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
    },
    getFormattedDate(date) {
      return date ? moment(date).format("DD-MM-YYYY hh:mm A") : "N/A";
    },
    confirmDelete(id) {
      (this.deleteDialog = true), (this.delete_id = id);
    },
    sessionStorage(search) {
      if (search === null || search === "" || search === undefined) {
        sessionStorage.removeItem("event_search");
      } else {
        const trimmedSearch = search.trim();
        this.search = trimmedSearch;
        sessionStorage.setItem("event_search", trimmedSearch);
      }
    },
    closeDialog() {
      this.deleteDialog = false;
      this.addEventDialog = false;
      this.event = {};
      this.$validator.reset();
      this.serverSideErrors = [];
    },
    debounceInput: debounce(function(){
      this.getEventTypeData(this.event_type[this.currentTab].id);
    }, 500),
  },
  mounted() {
    this.user = localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : {};
    this.event_value = sessionStorage.getItem("event_type");
    this.search = sessionStorage.getItem("event_search");
  },
};
</script>